// extracted by mini-css-extract-plugin
export default {"buttonLinkPrimary":"PlasmicButtonLinkPrimary_buttonLinkPrimary__9hDuo","slotTargetText":"PlasmicButtonLinkPrimary_slotTargetText__0a-aV"};